import {
  EMOTION_GET_NEWEST,
  EMOTION_GET_NEWEST_SUCCESS,
  EMOTION_GET_NEWEST_ERROR,
  EMOTION_GET_DETAILS,
  EMOTION_GET_DETAILS_SUCCESS,
  EMOTION_GET_DETAILS_ERROR,
} from '../actions';

const INIT_STATE = {
  loading: false,
  error: '',
  data_dashboard: null,
  item: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case EMOTION_GET_NEWEST:
      return { ...state, loading: true };
    case EMOTION_GET_NEWEST_SUCCESS:
      return {
        ...state,
        loading: false,
        data_dashboard: action.payload,
        error: '',
      };
    case EMOTION_GET_NEWEST_ERROR:
      return {
        ...state,
        loading: false,
        data_dashboard: null,
        error: action.payload
      };
    case EMOTION_GET_DETAILS:
      return { ...state, loading: true };
    case EMOTION_GET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.payload,
        error: '',
      };
    case EMOTION_GET_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        item: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
};
